<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import { cubicInOut } from "svelte/easing";
  import { scale } from "svelte/transition";
  import { setHeights } from "../../../shared/common";
  import { a } from "../../../shared/globalState/a";
  import { ObjectTypes } from "../../../shared/enums";

  interface IDrawingMode {
    appMode: string;
    fullName: string;
    isActive: boolean;
  }

  onMount(() => {
    setTimeout(() => {
        appModePanel = true;
    }, 500);
    a.drawingMode$.next(ObjectTypes.line);
  });

  let appModePanel = false;
  let dispatch = createEventDispatcher();
  let cub = cubicInOut;
  let sc = scale;

  let modes: IDrawingMode[] = [
    { appMode: ObjectTypes.line, fullName: "Линия", isActive: true },
     { appMode: ObjectTypes.networkSketch, fullName: "Набросок сети", isActive: false },
    { appMode: ObjectTypes.duct, fullName: "Воздуховод", isActive: false },
    // { appMode: ObjectTypes.pipe, fullName: "Труба", isActive: false },
  ];

  let curButtonIdSelected = ObjectTypes.line;
  let animationOptions = { delay: 0, duration: 500, easing: cub, start: 0.25, opacity: 1 };

  function handleClick(event) {

    var element = event.target;
    var id = element.id;
    curButtonIdSelected = id;
    
    modes.forEach((el) => (el.isActive = false));
    var mode: IDrawingMode | undefined = modes.find((el) => el.appMode === id);
    try {
        mode.isActive = true;
        a.drawingMode = mode.appMode;
        a.drawingMode$.next(mode.appMode);
    } catch (error) {
    }

  }


  function setVarHeights(e){
    setHeights();
  }

  function blurMe(e){
    setTimeout(() => {
      e.target.blur();
    }, 500);
  }

  
</script>

{#if appModePanel}
  <div class="flex-column" in:scale={animationOptions} use:setVarHeights>
    {#each modes as appMode, i}
      <button id={appMode.appMode} class:active={curButtonIdSelected === appMode.appMode} class="app-mode-button" on:click={handleClick} on:focus={blurMe}>{appMode.fullName}</button>
    {/each}
  </div>
{/if}

<style>
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .app-mode-button {
    text-align: start;
    padding: 0.35em 0.75em;
    border-radius: 5px;
    border: 1px solid var(--bg-slate-300);
    margin-bottom: 0.1em;
    background-color: var(--bg-slate-100);
    color: var(--color-slate-600);
    font-weight: 500;
    font-size: 15px;
    transition-property: background-color color;
    transition-duration: 0.25s;
  }
  .app-mode-button:active {
    transform: scale(0.9);
  }

  .app-mode-button:hover:not(.active) {
    background-color: var(--haiti-100);
  }
  .active {
    background-color: var(--haiti-400);
    color: var(--bg-slate-100);
  }
</style>
